import ShopDTO from "@/dto/shop/ShopDTO";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import OrderTableColumnsType from "@/scenes/OrderManagement/enum/OrderTableColumnsType";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { useGlobalStore } from "@/store/hooks";
import React, { useEffect, useState } from "react";

interface Props {
    shop?: ShopDTO;
    tab: OrderTab;
    checkedValue: OrderTableColumnsType[];
}

/**
 *
 * 加载快手【推荐快递】hooks
 *
 */
const useKsLogisticsRecommendEffect = (props: Props) => {
    const { shop, tab, checkedValue } = props;
    const orderManagementStore = useOrderManagementStore();
    const globalStore = useGlobalStore();
    const [showRecommendColumn, setShowRecommendColumn] = useState(false);

    useEffect(() => {
        if (checkedValue?.includes(OrderTableColumnsType.LOGISTICS_RECOMMEND)) {
            setShowRecommendColumn(true);
        } else {
            setShowRecommendColumn(false);
        }
    }, [checkedValue]);

    useEffect(() => {
        if (showRecommendColumn) {
            orderManagementStore.storage.loadKsLogisticsRecommendMapping(
                globalStore,
                orderManagementStore.table.orders,
                shop.id,
                tab,
            );
        }
    }, [showRecommendColumn, shop?.id, tab, orderManagementStore.table.orders]);
};

export default useKsLogisticsRecommendEffect;
